import { styled } from '@mui/material/styles'
import { Box, Drawer, Button, List, ListItemButton } from '@mui/material'

export const DRAWER_WIDTH = 300
export const COLLAPSED_WIDTH = 72

export const Container = styled(Box)({
  display: 'flex',
  height: '100vh',
})

// Added shouldForwardProp to prevent ownerState from reaching the DOM
export const SidebarDrawer = styled(Drawer, {
  shouldForwardProp: prop => prop !== 'ownerState',
})(({ theme, ownerState }) => ({
  width: ownerState.isSidebarOpen ? DRAWER_WIDTH : COLLAPSED_WIDTH,
  flexShrink: 0,
  '& .MuiDrawer-paper': {
    width: ownerState.isSidebarOpen ? DRAWER_WIDTH : COLLAPSED_WIDTH,
    boxSizing: 'border-box',
    display: 'flex',
    flexDirection: 'column',
    justifyContent: 'space-between',
    padding: theme.spacing(1),
    backgroundColor: '#fff',
    borderRight: '1px solid #e0e0e0',
    transition: theme.transitions.create('width', {
      easing: theme.transitions.easing.sharp,
      duration: theme.transitions.duration.enteringScreen,
    }),
    overflowX: 'hidden',
    alignItems: ownerState.isSidebarOpen ? 'stretch' : 'center',
  },
}))

export const SidebarContent = styled(Box, {
  shouldForwardProp: prop => prop !== 'ownerState',
})(({ ownerState }) => ({
  display: 'flex',
  flexDirection: 'column',
  width: '100%',
  flex: 1,
  overflowY: 'auto',
  padding: ownerState.isSidebarOpen ? '0' : '0 8px',
  '&::-webkit-scrollbar': {
    display: 'none',
  },
  msOverflowStyle: 'none',
  scrollbarWidth: 'none',
}))

export const Header = styled(Box, {
  shouldForwardProp: prop => prop !== 'ownerState',
})(({ ownerState }) => {
  const isSidebarOpenSafe = ownerState?.isSidebarOpen ?? true

  return {
    display: 'flex',
    justifyContent: isSidebarOpenSafe ? 'space-between' : 'center',
    alignItems: 'center',
    padding: isSidebarOpenSafe ? '0 8px 16px 8px' : '8px 0 16px 0',
  }
})

export const NewChatButton = styled(Button, {
  shouldForwardProp: prop => prop !== 'ownerState',
})(({ theme, ownerState }) => ({
  width: ownerState.isSidebarOpen ? '100%' : '36px',
  minWidth: 'unset',
  justifyContent: ownerState.isSidebarOpen ? 'flex-start' : 'center',
  textTransform: 'none',
  padding: ownerState.isSidebarOpen ? '10px 16px' : '',
  marginBottom: theme.spacing(2),
  backgroundColor: 'var(--brand-500)',
  marginTop: '16px',
  color: 'white',
  fontWeight: 600,
  borderRadius: ownerState.isSidebarOpen ? 32 : '50%',
  display: 'flex',
  alignItems: 'center',
  marginLeft: ownerState.isSidebarOpen ? 0 : 'auto',
  marginRight: ownerState.isSidebarOpen ? 0 : 'auto',

  '&:hover': {
    backgroundColor: 'var(--brand-active)',
  },
  '& .MuiButton-startIcon': {
    margin: ownerState.isSidebarOpen ? '0 8px -2px 0' : '0',
    '& > *:nth-of-type(1)': {
      fontSize: ownerState.isSidebarOpen ? '20px' : '24px',
    },
  },
}))

export const NavList = styled(List)({
  padding: 0,
})

// CHANGED: Inherit from ListItemButton for better click handling in MUI v5
export const NavListItem = styled(ListItemButton, {
  shouldForwardProp: prop => prop !== 'isActive',
})(({ theme, isActive }) => ({
  borderRadius: 8,
  marginBottom: theme.spacing(0.5),
  cursor: 'pointer',
  padding: theme.spacing(1),
  '&:hover': {
    backgroundColor: theme.palette.action.hover,
  },
  ...(isActive && {
    backgroundColor: 'rgba(0,0,0,0.05)',
    '& .MuiTypography-root, .MuiSvgIcon-root': {
      fontWeight: 600,
      color: 'inherit',
    },
  }),
}))

export const ProfileWrapper = styled(Box, {
  shouldForwardProp: prop => prop !== 'ownerState',
})(({ theme, ownerState }) => ({
  display: 'flex',
  position: 'sticky',
  bottom: 0,
  backgroundColor: '#fff',
  alignItems: 'center',
  padding: theme.spacing(1),
  borderTop: '1px solid #e0e0e0',
  cursor: 'pointer',
  justifyContent: ownerState.isSidebarOpen ? 'flex-start' : 'center',
  width: '100%',
}))
